import { useNavigate, useLocation } from 'react-router-dom';
import './SalesTologyFooter.css';
import logo from "../../assests/salestology-img01.webp"

const SalesTologyFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToHome = (e) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100);
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  const scrollToWhoWeAre = (e) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      setTimeout(() => {
        const element = document.getElementById('who-we-are-section');
        if (element) {
          const elementPosition = element.offsetTop - 80;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById('who-we-are-section');
      if (element) {
        const elementPosition = element.offsetTop - 80;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const scrollToWhatWeOffer = (e) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      setTimeout(() => {
        const element = document.getElementById('what-we-offer-section');
        if (element) {
          const elementPosition = element.offsetTop - 80;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById('what-we-offer-section');
      if (element) {
        const elementPosition = element.offsetTop - 80;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <footer className="footerMain">
      <div className="footerMain-container">
        {/* Logo Section */}
        <div className="footerMain-logo-section">
          <div className="footerMain-logo">
            <a href="/" className="logo logo-wrapper-footer">
              <img
                src={logo}
                alt="SalesTology Logo"
                className="logo-image"
              />
              <span className="trademark-icon-footer">®</span>
            </a>
          </div>
          <p className="footerMain-tagline">We grow sales</p>
        </div>

        {/* Quick Links */}
        <div className="footerMain-column">
          <h3 className="footerMain-title">Quick Links</h3>
          <ul className="footerMain-links">
            <li><a href="#home" onClick={scrollToHome}>Home</a></li>
            <li><a href="#who-we-are-section" onClick={scrollToWhoWeAre}>About Us</a></li>
            <li><a href="#what-we-offer-section" onClick={scrollToWhatWeOffer}>Services</a></li>
          </ul>
        </div>

        {/* Useful Links */}
        <div className="footerMain-column">
          <h3 className="footerMain-title">Useful Links</h3>
          <ul className="footerMain-links">
            <li><a href="/termsandconditions">Terms and Condition</a></li>
            <li><a target="_blank" href={process.env.REACT_APP_MEMBER_LOGIN_URL}>Member Login</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footerMain-column">
          <h3 className="footerMain-title">Contact Info.</h3>
          <div className="contact-item">
            <a href="mailto:zuheir.shahwan@salestology.com" className="contact-link">
              zuheir.shahwan@salestology.com
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footerMain-bottom">
        <div className="copyright-divider"></div>
        <div className="copyright">
          <p>Copyright © 2025 | SalesTology <span className="trademark-wrapper">®</span>  | All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default SalesTologyFooter;